import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import React from 'react'
import { connect } from 'react-redux'
import { controlHasError } from '../../lib/errorHandler'
import * as actions from '../../store/actions'
import ExpandablePanel from '../controls/ExpandablePanel'
import Button from '@material-ui/core/Button'

function IdentyfikacjaDomuMaklerskiegoR2({
  data,
  errors,
  onLoadGUS,
  onSetSectionData,
  onSetName,
}) {
  return (
    <ExpandablePanel title="IDENTYFIKACJA DOMU MAKLERSKIEGO">
      <form
        name="IdentyfikacjaPodmiotu"
        autoComplete="off"
        className="identyfikacjaPodmiotu"
      >
        <div className="krs">
          <FormControl component="fieldset" className="text">
            <TextField
              error={controlHasError(errors, 'NIP')}
              name="NIP"
              label="NIP"
              title={data.NIP}
              value={data.NIP}
              onChange={e => {
                onSetSectionData(e.target.name, e.target.value)
              }}
            />
          </FormControl>
          <FormControl component="fieldset" className="text">
            <TextField
              error={controlHasError(errors, 'KRS')}
              name="KRS"
              label="Numer KRS"
              title={data.KRS}
              value={data.KRS}
              onChange={e => {
                onSetSectionData(e.target.name, e.target.value)
              }}
            />
          </FormControl>
          <FormControl component="fieldset">
            <Button
              data-cy="getGus"
              className="buttonGUS"
              variant="contained"
              color="primary"
              onClick={() => {
                if (data.NIP) onLoadGUS(false, data.NIP)
                else if (data.KRS) onLoadGUS(true, data.KRS)
              }}
            >
              POBIERZ DANE Z GUS
            </Button>
          </FormControl>
        </div>
        <FormControl component="fieldset">
          <TextField
            error={controlHasError(errors, 'NazwaFirmy')}
            name="NazwaFirmy"
            label="Nazwa (firma)"
            title={data.NazwaFirmy}
            value={data.NazwaFirmy}
            onChange={e => {
              onSetSectionData(e.target.name, e.target.value)
              onSetName(e.target.value)
            }}
          />
        </FormControl>
      </form>
    </ExpandablePanel>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    onSetName: name => dispatch(actions.setName(name)),
  }
}

export default connect(
  null,
  mapDispatchToProps,
)(IdentyfikacjaDomuMaklerskiegoR2)
